export function Builder() {
    this.listFieldValues = [];
    this.mapObjects = [];
}

/**
 * Función que construye un mapa con las instituciones para poder mostrar
 * como agrupamientos en la tabla de detalle.
 * @param listObjects Es cada uno de los elementos de la lista.
 * @param field Campo por el cual se va a agrupar.
 */
Builder.prototype.groupList = function (listObjects, field) {
    listObjects.forEach(function (item) {
        let orderField = item[field];
        let itemList = [];
        let objAux = {};

        if (this.listFieldValues.includes(orderField)) {
            objAux = this.mapObjects.find(inst => inst[field] === orderField);
            let index = this.mapObjects.indexOf(objAux);
            itemList = objAux['items'];
            itemList.push(item);
            objAux['items'] = itemList;
            this.mapObjects[index] = objAux;
        } else {
            this.listFieldValues.push(item[field]);
            itemList.push(item);
            objAux = {
                [field]: item[field],
                items: itemList
            }
            this.mapObjects.push(objAux);
        }
    }, this);
}
